export default {
	NAME_APP: 'iSystem 4',
	VERSION: 'v0.0.1',
	ENVIRONMENT: 'PRO', 
	WEB_ISYSTEM: {
		DEV: 'http://10.10.38.43:8000/',
		PRO: 'https://api.isystem4.aceschile.cl/'
	},
	API_BACKEND_ISYSTEM: {
		DEV: 'http://10.10.38.43:8000/api/',
		PRO: 'https://api.isystem4.aceschile.cl/api/'
	},
	SOCKETIO_ISYSTEM: {
		DEV: 'http://socket.aceschile.cl:3000',
		PRO: 'http://socket.aceschile.cl:3000'
	},
	URL_WEB_SOCKET_FACTURACIONCL: 'ws://localhost:8005'
}